// Public browser configuration. Never put server secrets here.
const supplied = typeof window === "undefined" ? {} : (window.__APP_CONFIG__ || {});
const runtimeConfig = {
  REACT_APP_API_URL: supplied.REACT_APP_API_URL !== undefined ? supplied.REACT_APP_API_URL : (process.env.REACT_APP_API_URL || "/api/"),
};
export default runtimeConfig;
